import { Box, FormHelperText, Grid, TextField, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { theme } from "../../../utils/theme";
import React from "react";
import { IContactEmailData } from "../ContactAddressData";
import { asteriskStyle, emailReceivedTextStyle, emailReceivedBoxStyle } from "../styled";

interface IVerifyEmailProps {
  data: IContactEmailData;
  email: string;
  emailError: boolean;
  onSetEmail: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  submissionSuccess: boolean;
  readOnly: boolean;
}

export const VerifyEmail: React.FC<IVerifyEmailProps> = ({
  data,
  email,
  emailError,
  onSetEmail,
  submissionSuccess,
  readOnly,
}) => (
  <Box sx={{ p: { xs: 0, md: 2 } }}>
    <Grid container spacing={2} sx={{ justifyContent: "center" }}>
      <Grid
        item
        xs={12}
        md={8}
        sx={{ p: 0 }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography variant="form-label" data-automation="email-lbl">
            Email
            <Typography component={"span"} sx={asteriskStyle}>
              &nbsp;*
            </Typography>
          </Typography>
          <TextField
            fullWidth
            value={email}
            onChange={onSetEmail}
            placeholder="Enter your email"
            error={emailError}
            inputProps={{
              maxLength: 100,
              autoCapitalize: "none",
            }}
            InputProps={{ readOnly }}
            className={readOnly ? "readonly" : ""}
            data-automation="email-field"
        />
          <FormHelperText
            component={"div"}
            data-automation="invalid-email-lbl"
            error={emailError}
          >
            {emailError ? "Invalid Email Address" : ""}
          </FormHelperText>
          {<Box sx={{mt: 2, ml: 0.5, mr: 1, color: theme.palette.corporateBlue, display: "flex"}}>
              <InfoIcon sx={{fontSize: "20px"}} />
              <Typography
                component="span"
                sx={{ml: 1, fontSize: "12px"}}
                data-automation="email-disclaimer"
              >
              BCMEA collects your email for the purpose of user verification for your MyBCMEA account 
              and to communicate with you in connection with your employment.
              </Typography>
          </Box>}
          {submissionSuccess && (
            <Box sx={emailReceivedBoxStyle} data-automation="email-received-lbl">
              <Typography sx={emailReceivedTextStyle}>Thank you!</Typography>
              <Typography sx={emailReceivedTextStyle}>
                Email received. Please verify it by clicking the link in the
                verification email we've sent. Then, return to this page and
                refresh it.
              </Typography>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  </Box>
);
